import { signDocument } from '@/api/Documents';
import { Documents } from '@/types/company';
import { useMutation } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

export const useSignDocument = () => {
  return useMutation<
    AxiosResponse,
    AxiosError<Documents.SignDocumentErrorResponse>,
    Documents.SignDocumentPayload
  >({
    mutationFn: signDocument,
  });
};
